import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Loader from '../../Common/Loader';

export default function (props) {
	return (
		<section>
			<Container component="main" maxWidth="md">
				<div className={props.className}>
					<Grid container id="reduce-width" justify="center" spacing={5}>
						<Grid id="shadow-round" item sm={8} xs={12}>
							<Grid container id="padding-20" spacing={3}>
								{props.children}
							</Grid>
						</Grid>
					</Grid>
				</div>
			</Container>
			{props.isLoading ? <Loader /> : ''}
		</section>
	);
}
